import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { InputGroup } from "react-bootstrap";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Button } from "bootstrap-4-react/lib/components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import noImage from "../../assets/No-Image-Placeholder.png";
import { useEffect } from "react";
import Select from 'react-select';
import {
  createpackage,
  getAllCarrierList,
  getPackageDetails,
  getPackagetypeList,
  getSourceListList,
  getStatusList,
  resetPackage,
  updateImageForPackage,
  updatepackage,
} from "../../store/actions/incoming";
import { getAllCompanyDetails } from '../../store/actions/rateCard';
import { getSellersforMultipleCompany } from '../../store/actions/company';
import { getSelectList } from '../../config/utils';
import moment from "moment";
import LoaderSpinner from "../common/Loader";
import { allowedExtensions, featureSubmodulePermission, packages, permssionCreate, returnsManagement, trackingNum } from "../../constant";
import ImageSlider from "./ImageSlider";
import _ from "lodash";
import InLargeImageSlider from "../modal/InlargeImageSlider";
import { checkPermission } from "../../config/utils";
import PropTypes from "prop-types";

// Shared styles for Select components
const selectStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: '28px',
    height: '36px',
    fontSize: '13px',
    paddingTop: '0.5px'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#515558ff'
  })
};

/* istanbul ignore next */
const EditPackages = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { view = null, date = null } = location?.state || {};

  const [error, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [isFormEdited, setIsFormEdited] = useState(false);
  const [image, setImage] = useState([]);
  const [formDataCopy, setFormDataCopy] = useState([]);
  const [showLargeSliderModal, setShowLargeSliderModal] = useState(false);

  const UserValue = useSelector((state) => state.auth.user);
  const {
    packageDetailsById,
    packageDetailStatus,
    PackageTypeList,
    sourcesList,
    allCarriersList,
    statusList,
  } = useSelector((state) => state.IncomingReducer);

  // Company and Seller selectors
  const { getAllCompany } = useSelector((state) => state.RateCardReducer);
  const getSellersValue = useSelector((state) => state.company?.getMultipleCompanySellers);

  const [formData, setFormData] = useState({
    internalId: "",
    externalId: "",
    trackingNumber: "",
    packageType: "",
    source: "",
    receivedDate: new Date(),
    carrierId: "",
    statusId: 1,
    companyId: 0,
    sellerId: 0,
  });

  // Company and Seller dropdown state
  const [companyList, setCompanyList] = useState([]);
  const [sellerList, setSellerList] = useState([]);

  const dispatch = useDispatch();
  let { id } = useParams();
  let isCreateForm = parseInt(id) === 0; // NOSONAR

  useEffect(() => {
    if (parseInt(id) !== 0) { // NOSONAR
      dispatch(getPackageDetails(id));
    }
  }, [id]);

  useEffect(() => () => {
    dispatch(resetPackage());
  }, []);

  useEffect(() => {
    if (!sourcesList?.length) {
      dispatch(getSourceListList());
      dispatch(getPackagetypeList());
    }
    if (!allCarriersList.length) {
      dispatch(getAllCarrierList());
    }

    if (!statusList.length) {
      dispatch(getStatusList());
    }

    // Get all company details for dropdown (only for super admin and edit mode)
    if (UserValue?.Value?.isSuperAdmin && !isCreateForm) {
      dispatch(getAllCompanyDetails(null, 500, 1)); // Use same parameters as Tasks component
    }
  }, []);

  useEffect(() => {
    if (parseInt(id) !== 0) { // NOSONAR
      setFormDataCopy(JSON.parse(JSON.stringify(packageDetailsById)));
      setFormData(packageDetailsById);

      // For existing package, if it has companyId, fetch sellers for that company (only for super admin)
      if (UserValue?.Value?.isSuperAdmin && packageDetailsById?.companyId) {
        dispatch(getSellersforMultipleCompany([packageDetailsById.companyId]));
      }
    } else {
      setFormData({
        ...formData,
        companySellerId: UserValue?.Value?.companySellerId,
      });
    }
  }, [packageDetailsById]);

  useEffect(() => {
    if (packageDetailStatus === "pending") {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [packageDetailStatus]);

  // Company and Seller list effects - matching Tasks component structure
  useEffect(() => {
    let companyData = getAllCompany?.Entity?.listCompanyMasterOrdersEntity || [];
    if (companyData.length) {
      // map to { value, label } - exact same as Tasks
      setCompanyList(getSelectList(companyData, 'Id', 'name'));
    }

    let sellerData = getSellersValue?.Entity?.listSellerMasterOrdersEntity || [];
    if (sellerData.length) {
      setSellerList(getSelectList(sellerData, 'id', 'sellerAndCompany'));
    } else {
      setSellerList([]);
    }
  }, [getAllCompany, getSellersValue]);

  const validateForm = () => {
    const errorData = {};
    let isValid = true;

    const addError = (field, message) => {
      isValid = false;
      errorData[field] = message;
    };

    const validateFields = (fields) => {
      fields.forEach(({ key, message }) => {
        if (!formData?.[key]) addError(key, message);
      });
    };

    const isSeller = UserValue?.Value?.roleName === "Seller";
    const isSuperAdminEdit = UserValue?.Value?.isSuperAdmin && !isCreateForm;

    if (isSeller) {
      validateFields([
        { key: "notes", message: "Notes is required" },
        { key: "carrierId", message: "This is required" },
      ]);
    } else {
      validateFields([
        { key: "packageType", message: "packageType is required" },
        { key: "source", message: "source is required" },
        { key: "carrierId", message: "This is required" },
      ]);

      if (isSuperAdminEdit) validateCompanySellerRelation(addError);
    }

    setErrors(errorData);
    return isValid;
  };

  const validateCompanySellerRelation = (addError) => {
    const hasCompany = formData.companyId && formData.companyId !== 0;
    const hasSeller = formData.sellerId && formData.sellerId !== 0;

    if (hasCompany && !hasSeller) {
      addError("sellerId", "Seller is required when company is selected");
    } else if (hasSeller && !hasCompany) {
      addError("companyId", "Company is required when seller is selected");
    }
  };

  const validateCreateForm = () => {
    let isValid = true;
    let errorData = {};
    if (!formData?.packageTypeId) {
      isValid = false;
      errorData.packageTypeId = "This is required";
    }
    if (!formData?.sourceId) {
      isValid = false;
      errorData.sourceId = "This is required";
    }
    if (!image.length) {
      isValid = false;
      errorData.image = "This is required";
    }
    if (!formData.carrierId) {
      isValid = false;
      errorData.carrierId = "This is required";
    }

    // Note: Company and Seller validation not needed for create form as dropdowns are not shown

    setErrors(errorData);
    return isValid;
  };

  const handleFormChange = (e) => {
    const { value, name } = e.target;
    if (name === "trackingNumber") {
      if (value) {
        if (!trackingNum.test(value)) {
          return false;
        }
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...error,
      [name]: "",
    });
    setIsFormEdited(true);
  }
  const handleSliderDeleteImage = (e, item) => {
    let formDataObj = JSON.parse(JSON.stringify(formData));
    let updateImage = formDataObj.boxImages.filter((box) => box.id !== item.id);
    formDataObj.boxImages = updateImage;

    let cloneFormData = JSON.parse(JSON.stringify(formDataCopy));
    let updateImageToCopyObj = formDataCopy.boxImages.map((box) => {
      return {
        ...box,
        isDeleted: box.id === item.id || box.isDeleted ? true : false,
        isPrimary: box.id === item.id && false,
      };
    });
    cloneFormData.boxImages = updateImageToCopyObj;
    setFormDataCopy(cloneFormData);

    setIsFormEdited(true);
    setFormData(formDataObj);
  };
  const handleMarkPrimary = (e, item) => {
    let formDataCopyObj = JSON.parse(JSON.stringify(formData));
    let updateImage = formDataCopyObj.boxImages.map((box) => {
      return {
        ...box,
        isPrimary: box.id === item.id ? true : false,
      };
    });
    formDataCopyObj.boxImages = updateImage;
    setIsFormEdited(true);
    setFormData(formDataCopyObj);
  }
  const handleCreatePackage = async () => {
    let data = { ...formData };
    data.externalId = null;
    data.createdBy = UserValue?.Value?.employeeId;
    setLoader(true);
    let response = await Promise.resolve(dispatch(createpackage(data)));
    if (response && response?.data?.Status === 200) {
      let uploadImgData = new FormData();
      uploadImgData.append("InternalId", response?.data?.Entity);

      for (let i = 0; i < image.length; i++) {
        uploadImgData.append("BoxImages", image[i]);
      }
      let uploadRes = await Promise.resolve(dispatch(updateImageForPackage(uploadImgData)));
      if (uploadRes && uploadRes?.data?.Status === 200) {
        navigate(
          `/incoming-packages/fd-${new Date(
            formData.receivedDate
          ).toISOString()}-3pl/${response?.data?.Entity}`,
          { state: { view: true, date: location?.state?.date } }
        );
        setIsFormEdited(false);
        toast.success("Changes Saved Successfully");
        setImage("");
      } else {
        toast.error(uploadRes?.data?.Message?.AppStatusDescription);
      }
      setLoader(false);
    } else {
      toast.error(response?.data?.Message?.AppStatusDescription);
      setLoader(false);
    }
  }

  const handleSave = async (e) => {
    e.preventDefault();
    if (isCreateForm) {

      if (validateCreateForm()) {
        handleCreatePackage();
      }
    } else if (validateForm()) {
        handleUpdatePackage();
      }
    
  }
  const handleUpdatePackage = async () => {
    setLoader(true);
    try {
      const updateRes = prepareUpdatePayload(formData, formDataCopy, UserValue);
      const response = await Promise.resolve(dispatch(updatepackage(updateRes)));

      if (!response || response?.data?.Status !== 200) {
        handleApiError(response);
        return;
      }

      // If images need to be uploaded
      if (image.length) {
        const uploadSuccess = await uploadImages(formData.internalId, image);
        if (!uploadSuccess) return;
      }

      handleSuccessNavigation();
    } catch (error) {
      toast.error("An error occurred while updating the package. Please try again.");
      console.error("Update package error:", error);
    } finally {
      setLoader(false);
    }
  };

  /** 🔹 Helper Functions **/

  const prepareUpdatePayload = (formData, formDataCopy, UserValue) => {
    const updateRes = JSON.parse(JSON.stringify(formData));
    const mergeImage = [...formData.boxImages, ...formDataCopy.boxImages];
    updateRes.companySellerId = UserValue?.Value?.companySellerId;
    updateRes.boxImages = _.uniqBy(mergeImage, "id");
    updateRes.modifiedBy = UserValue?.Value?.employeeId;

    return renamePayloadFields(updateRes);
  };

  const renamePayloadFields = (data) => {
    if (data.companyId !== undefined) {
      data.assignedToCompanyId = data.companyId;
      delete data.companyId;
    }
    if (data.sellerId !== undefined) {
      data.assignedToSellerId = data.sellerId;
      delete data.sellerId;
    }
    return data;
  };

  const uploadImages = async (internalId, image) => {
    const uploadImgData = new FormData();
    uploadImgData.append("InternalId", internalId);
    image.forEach(img => uploadImgData.append("BoxImages", img));

    const uploadRes = await Promise.resolve(dispatch(updateImageForPackage(uploadImgData)));
    if (uploadRes?.data?.Status === 200) return true;

    const errMsg =
      uploadRes?.data?.Message?.AppStatusDescription ||
      "Failed to upload images. Please try again.";
    toast.error(errMsg);
    return false;
  };

  const handleSuccessNavigation = () => {
    navigate(`/incoming-packages/fd-${date}-3pl/${id}`, {
      state: { view: true, date: location?.state?.date },
    });
    toast.success("Changes Saved Successfully");
    setIsFormEdited(false);
    dispatch(getPackageDetails(id));
    setImage("");
  };

  const handleApiError = (response) => {
    const errorMessage =
      response?.data?.Message?.AppStatusDescription ||
      response?.data?.Message ||
      "Failed to update package. Please try again.";
    toast.error(errorMessage);
    setLoader(false);
  };


  const handleEdit = () => {
    navigate(`/incoming-packages/fd-${date}-3pl/${id}`, {
      state: { view: false, date: location?.state?.date },
    });
  };
  const handleBack = () => {
    if (location?.state?.fromApprovalScreen) {
      navigate(`/package-assignment-approval`);
      return;
    }
    if (isCreateForm) {
      navigate(`/incoming-packages`);
      return;
    } else {
      navigate(`/incoming-packages/fd-${date}-3pl`, {
        state: { date: location?.state?.date },
      });
      return;
    }
  };
  const handleImageUpload = (e) => {
    let files = [...e.target.files];
    try {
      if (files.length > 0 && files.length <= 5) {
        let filterFiles = files.filter((file, index) => {
          const extension = file?.name?.split(".").slice(-1).pop();
          const fileSize = Math.round(file.size / 1024);
          if (
            !allowedExtensions.includes(
              extension ? extension.toLowerCase() : ""
            )
          ) {
            files.splice(index, 1);
            return false;
          } else if (fileSize > 1024) {
            files.splice(index, 1);
            e.target.value = "";
            return false;
          }
          return file;
        });
        setErrors({ ...error, image: "" });
        setImage(filterFiles);
        setIsFormEdited(true);
        if (e.target.files.length !== files.length) {
          toast.info("Each picture size should be less than 1MB", 1000);
          e.target.value = "";
        }
      } else if (files.length > 5) {
        toast.info("5 images can be upload at one time", 1000);
        e.target.value = "";
      } else {
        e.target.value = "";
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleDeleteImage = (index) => {
    let images = [...image];
    images.splice(index, 1);
    setImage(images);
  };

  const handleDateChange = (receivedDate) => {
    setFormData({
      ...formData,
      receivedDate: moment(receivedDate).format("MM-DD-YYYY"),
    });
    setIsFormEdited(true);
  };
  const renderTitle = () => {
    let title;
    if (parseInt(id) === 0) { // NOSONAR
      title = "Create Package";
    } else if (!view) {
      title = "Edit Package Details";
    } else {
      title = "Package Details";
    }
    return title
  }

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec">
          {renderTitle()}
          <div></div>
          <div className="top_right_button_container">
            {checkPermission(returnsManagement, packages, permssionCreate, featureSubmodulePermission, props.employeePermissions) && (
              <Button
                disabled={!isFormEdited}
                className="cus-seconday-bg-btn top-btn"
                id="savesr"
                onClick={handleSave}
              >
                Save
              </Button>
            )}

            {!isCreateForm && UserValue?.Value?.roleName !== "Seller" && (
              <Button
                disabled={!view}
                className="cus-seconday-bg-btn top-btn"
                id="hde"
                onClick={handleEdit}
              >
                Edit
              </Button>
            )}
            <Button
              className="cus-primary-transparent-btn top-btn"
              id="hdb"
              onClick={() => handleBack()}
            >
              Back
            </Button>
          </div>
        </div>
        {loader && <LoaderSpinner />}
        <div className="main_content cus-page-content-sec">
          <div className="top_right_button_container cus-content-only-sec">
            <div className="incoming_wrapper pt-3">
              <div className="row">
                <div className={parseInt(id) === 0 ? "col-12" : "col-lg-9 col-sm-12"}> {/* NOSONAR */}
                  <div className="blank fontFix">
                    <Row className="mb-2 p-2 rowBottomSpace">
                      {/* Company and Seller Dropdowns - Only for Edit mode and Super Admin */}
                      {UserValue?.Value?.isSuperAdmin && !isCreateForm && (
                        <>
                          <Col xs={12} lg={3}>
                            <div className="input-label-Created-date">
                              Company {!!(formData.sellerId && formData.sellerId !== 0) && <span className="require-field">*</span>}
                            </div>
                            <div className="select_react">
                              <Select
                                options={companyList}
                                onChange={(opt) => {
                                  const val = opt?.value || 0;
                                  setFormData(prev => ({
                                    ...prev,
                                    companyId: val,
                                    sellerId: 0 // Reset seller when company changes
                                  }));
                                  setIsFormEdited(true); // Enable save button when company changes
                                  // fetch sellers for selected company
                                  if (val && val !== 0) {
                                    dispatch(getSellersforMultipleCompany([val]));
                                  }
                                }}
                                className="activeSellerListInput"
                                isDisabled={view} // Only disable for view mode since we're only showing in edit mode
                                value={companyList?.find(c => c.value === formData.companyId) || null}
                                placeholder="Select Company..."
                                isMulti={false}
                                classNamePrefix="list-value"
                                styles={selectStyles}
                              />
                            </div>
                            {error.companyId && (
                              <div className="requiredthis">
                                *{error.companyId}
                              </div>
                            )}
                          </Col>
                          <Col xs={12} lg={3}>
                            <div className="input-label-Created-date">
                              Seller {!!(formData.companyId && formData.companyId !== 0) && <span className="require-field">*</span>}
                            </div>
                            <div className="select_react">
                              <Select
                                options={sellerList}
                                onChange={(opt) => {
                                  setFormData(prev => ({ ...prev, sellerId: opt?.value || 0 }));
                                  setErrors(prev => ({ ...prev, sellerId: "" }));
                                  setIsFormEdited(true); // Enable save button when seller changes
                                }}
                                className="activeSellerListInput"
                                isDisabled={view} // Only disable for view mode since we're only showing in edit mode
                                value={sellerList?.find(s => s.value === formData.sellerId) || null}
                                placeholder="Select Seller..."
                                isMulti={false}
                                classNamePrefix="list-value"
                                styles={selectStyles}
                              />
                            </div>
                            {error.sellerId && (
                              <div className="requiredthis">
                                *{error.sellerId}
                              </div>
                            )}
                          </Col>
                        </>
                      )}

                      <Col xs={12} lg={3}>
                        <InputGroup>
                          <div className="input-label-Created-date">
                            Tracking Number
                          </div>
                          <div className="input-box">
                            <input
                              disabled={view}
                              onChange={handleFormChange}
                              value={formData?.trackingNumber}
                              name={"trackingNumber"}
                              className="form-control"
                              maxLength={20}
                            />
                          </div>
                          {error.trackingNumber && (
                            <div className="requiredthis">
                              *This is required
                            </div>
                          )}
                        </InputGroup>
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputGroup>
                          <div className="input-label-Created-date ">
                            Package Type{" "}
                            <span className="require-field">*</span>
                          </div>
                          <div>
                            <select
                              disabled={view}
                              onChange={handleFormChange}
                              value={formData?.packageTypeId}
                              name={"packageTypeId"}
                              className="form-control noMarginBtm"
                            >
                              {isCreateForm && (
                                <option selected value>
                                  Select
                                </option>
                              )}
                              {PackageTypeList?.length &&
                                PackageTypeList.map((item, index) => (
                                  <option key={item.id} value={item.id}>
                                    {item.packageType}
                                  </option>
                                ))}
                            </select>
                          </div>
                          {error.packageTypeId && (
                            <div className="requiredthis">
                              *This is required
                            </div>
                          )}
                        </InputGroup>
                      </Col>
                    </Row>

                    <Row className="mb-2 p-2 rowBottomSpace">
                      <Col xs={12} lg={3}>
                        <InputGroup>
                          <div className="input-label-Created-date ">
                            Source <span className="require-field">*</span>
                          </div>
                          <div className="input-box">
                            <select
                              disabled={view}
                              onChange={handleFormChange}
                              value={formData?.sourceId}
                              name={"sourceId"}
                              className="form-control noMarginBtm"
                            >
                              {isCreateForm && (
                                <option selected value>
                                  Select
                                </option>
                              )}
                              {sourcesList?.length &&
                                sourcesList.map((item, index) => (
                                  <option value={item.id} key={item.id}>
                                    {item.source}
                                  </option>
                                ))}
                            </select>
                          </div>
                          {error.sourceId && (
                            <div className="requiredthis">
                              *This is required
                            </div>
                          )}
                        </InputGroup>
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputGroup>
                          <div className="input-label-Created-date ">
                            Received Date{" "}
                            <span className="require-field">*</span>
                          </div>
                          <div>
                            {formData?.receivedDate && (
                              <DatePicker
                                disabled={view}
                                className="form-control receivedDate"
                                dateFormat="MM-dd-yyyy"
                                onChange={(receivedDate) =>
                                  handleDateChange(receivedDate)
                                }
                                showIcon
                                selected={formData?.receivedDate ? new Date(formData.receivedDate) : null}
                                name={"receivedDate"}
                              />
                            )}
                          </div>
                          {error.receivedDate && (
                            <div className="requiredthis">
                              *This is required
                            </div>
                          )}
                        </InputGroup>
                      </Col>
                      <Col xs={12} lg={3}>
                        <div className="input-label-Created-date ">
                          Carrier <span className="require-field">*</span>
                        </div>
                        <div>
                          <select
                            disabled={view}
                            onChange={handleFormChange}
                            value={formData?.carrierId}
                            name={"carrierId"}
                            className="form-control noMarginBtm"
                          >
                            {isCreateForm && (
                              <option selected value="0">
                                Select
                              </option>
                            )}
                            {allCarriersList?.length &&
                              allCarriersList.map((item) => (
                                <option value={item.id} key={item.id}>
                                  {item.carrierName}
                                </option>
                              ))}
                          </select>
                          {error.carrierId && (
                            <div className="requiredthis">
                              *This is required
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col xs={12} lg={3}>
                        <div className="input-label-Created-date ">
                          Status
                        </div>
                        <div>
                          <select
                            disabled={
                              isCreateForm ||
                              view ||
                              !(
                                UserValue?.Value?.isSuperAdmin ||
                                UserValue?.Value?.isAdmin
                              )
                            }
                            onChange={handleFormChange}
                            value={formData?.statusId}
                            name={"statusId"}
                            className="form-control noMarginBtm"
                          >
                            {isCreateForm && (
                              <option selected value>
                                Select
                              </option>
                            )}
                            {statusList?.length &&
                              statusList.map((item) => (
                                <option value={item.id} key={item.id}>
                                  {item.status}
                                </option>
                              ))}
                          </select>
                        </div>
                      </Col>

                      <Col xs={12} lg={3}>
                        <InputGroup>
                          <div className="input-label-Created-date pt-3">
                            Image{" "}
                            {isCreateForm ? (
                              <span className="require-field">*</span>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div>
                            <div className="fileUpload">
                              <button
                                disabled={view}
                                type="button"
                                className="btn cus-seconday-bg-btn"
                              >
                                Upload image
                              </button>
                              <input
                                className="hiddenFileField"
                                onChange={handleImageUpload}
                                disabled={view}
                                type="file"
                                id="customFile"
                                multiple
                              />
                            </div>
                            {error.image && (
                              <div className="requiredthis">
                                *This is required
                              </div>
                            )}
                            <div>
                              {image.length > 0 &&
                                image.map((item, index) => (
                                  <div
                                    className="selectedFile"
                                    key={item?.id}
                                  >
                                    <div className="fileName">{item.name}</div>
                                    <button
                                      onClick={() => handleDeleteImage(index)}
                                    >
                                      <i
                                        className="fa fa-times"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </InputGroup>
                      </Col>

                    </Row>
                    <Row className="mb-2 p-2 rowBottomSpace">
                      <Col xs={12}>
                        <Form.Group>
                          <div>
                            VC Seller Comment (if any)
                          </div>
                          <textarea
                            disabled={view}
                            type={"text"}
                            name={"vcSellerComment"}
                            value={formData?.vcSellerComment}
                            className="form-control incomingTextarea"
                            onChange={handleFormChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="cus-mar-bottom20 p-2">
                      <Col xs={12}>
                        <Form.Group>
                          <div className="">Notes</div>
                          <textarea
                            disabled={view}
                            type={"text"}
                            name="notes"
                            rows={8}
                            value={formData.notes}
                            className="form-control incomingTextarea"
                            onChange={handleFormChange}
                          />
                          {error.notes && (
                            <div className="requiredthis">
                              *This is required
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>
                {parseInt(id) !== 0 && ( // NOSONAR
                  <div className="col-3">
                    {formData?.boxImages?.length ? (
                      <ImageSlider
                        isView={view}
                        handleMarkPrimary={handleMarkPrimary}
                        images={formData.boxImages}
                        handleDeleteImage={handleSliderDeleteImage}
                        isUserAdmin={UserValue?.Value?.isSuperAdmin}
                        setShowLargeSliderModal={setShowLargeSliderModal}
                        showLargeSliderModal={showLargeSliderModal}
                      />
                    ) : (
                      <img src={noImage} alt="" />
                    )}
                  </div>
                )}
              </div>
            </div>
            <InLargeImageSlider
              popupTitle={'Package'}
              view={view}
              handleMarkPrimary={handleMarkPrimary}
              images={formData.boxImages}
              handleSliderDeleteImage={handleSliderDeleteImage}
              isUserAdmin={UserValue?.Value?.isSuperAdmin}
              showModal={showLargeSliderModal}
              setShowLargeSliderModal={setShowLargeSliderModal}
            />
          </div>
        </div>
      </div>
    </main>
  );
};

EditPackages.propTypes = {
  employeePermissions: PropTypes.array,
};

export default EditPackages;
